export default {"src":"/_next/static/media/homepage-fb-footer-icon-desktop-white.b949f3f2.svg","height":35,"width":17,"blurWidth":0,"blurHeight":0};